import React from "react";

import { MyListingsWrapper } from "../../components";

export default function MyListingsPage() {
  return <MyListingsWrapper />;
}
